import React from 'react'
import ButtonD from '../button/button'
import { Layout } from 'antd'
import {
  GithubOutlined,
  MobileOutlined,
} from '@ant-design/icons'
import './footer.css'

const { Footer } = Layout

const links = [
  {
    tooltip: 'https://vk.com/greedos',
    shape: 'circle',
    icon: null,
    type: 'primary',
    text: 'VK',
  },
  {
    tooltip: 'tel:+79185673662',
    shape: 'circle',
    icon: <MobileOutlined />,
    type: 'primary',
    text: '',
  },
  {
    tooltip: 'https://github.com/Greed2kk',
    shape: 'circle',
    icon: <GithubOutlined />,
    type: 'ghost',
    text: '',
  },
  {
    tooltip:
      'https://rostov.hh.ru/resume/17be61e5ff0722c7140039ed1f42314f416530',
    shape: 'danger',
    icon: null,
    type: 'primary',
    text: 'hh.ru',
  },
  {
    tooltip: 'https://web.telegram.org/#/im?p=@greeree',
    shape: 'primary',
    icon: null,
    type: 'primary',
    text: 'Telegram',
  },
]

const redirectHandler = link => {
  window.location.href = link
}

const renderButtons = () => {
  return links.map(
    ({ tooltip, shape, icon, type, text }, index) => (
      <ButtonD
        redirect={redirectHandler}
        key={index}
        tooltip={tooltip}
        shape={shape}
        icon={icon}
        type={type}
        text={text}
      />
    )
  )
}

const FooterD = () => <Footer>{renderButtons()}</Footer>

export default FooterD
